"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.DpMasteryDetailByClass = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var react_i18next_1 = require("react-i18next");
var styled_components_1 = require("styled-components");
var DpStackedBar_1 = require("../StackedBar/DpStackedBar");
var DpSectionCard_1 = require("../Cards/DpSectionCard");
var api_1 = require("../../../api");
var DpMasteryDetailByClass_styled_1 = require("./DpMasteryDetailByClass.styled");
var DpProficientBandLegend_1 = __importDefault(require("../ProficientBandLegend/DpProficientBandLegend"));
var AtomicAlertManagerContext_1 = require("../AtomicAlert/AtomicAlertManagerContext");
var themeBands = (_a = {},
    _a[api_1.Bands.NotProficient] = 'notYet',
    _a[api_1.Bands.PartiallyProficient] = 'partial',
    _a[api_1.Bands.HighlyProficient] = 'highlyProficient',
    _a[api_1.Bands.Proficient] = 'proficient',
    _a);
var DpMasteryDetailByClass = function (_a) {
    var _b;
    var _c, _d, _e, _f, _g, _h, _j, _k;
    var bands = _a.bands, classPerformance = _a.classPerformance, curriculum = _a.curriculum;
    // --------------------------- Contexts and Props
    var t = (0, react_i18next_1.useTranslation)('common').t;
    var themeContext = (0, react_1.useContext)(styled_components_1.ThemeContext);
    var analyticsService = (0, react_1.useContext)(api_1.ServiceContext).analyticsService;
    var toast = (0, react_1.useContext)(AtomicAlertManagerContext_1.AtomicAlertManagerContext).toast;
    var legendColors = (_b = {},
        _b[api_1.Bands.NotProficient] = (0, api_1.findPerformanceBandColor)(themeContext, (0, api_1.getCurriculumPrefixFromCurriculum)(curriculum), themeBands['not-proficient']),
        _b[api_1.Bands.Proficient] = (0, api_1.findPerformanceBandColor)(themeContext, (0, api_1.getCurriculumPrefixFromCurriculum)(curriculum), themeBands.proficient),
        _b[api_1.Bands.PartiallyProficient] = (0, api_1.findPerformanceBandColor)(themeContext, (0, api_1.getCurriculumPrefixFromCurriculum)(curriculum), themeBands['partially-proficient']),
        _b[api_1.Bands.HighlyProficient] = (0, api_1.findPerformanceBandColor)(themeContext, (0, api_1.getCurriculumPrefixFromCurriculum)(curriculum), themeBands['highly-proficient']),
        _b);
    var bandLabelColor = (0, react_1.useMemo)(function () { return ({
        'not-proficient': themeContext.Colors.dark,
        proficient: themeContext.Colors.dark,
        'partially-proficient': themeContext.Colors.dark,
        'highly-proficient': themeContext.Colors.dark,
    }); }, [themeContext]);
    // --------------------------- State
    var _l = (0, react_1.useState)(false), initialized = _l[0], setInitialized = _l[1];
    var _m = (0, react_1.useState)([]), stackedBarData = _m[0], setStackedBarData = _m[1];
    // --------------------------- Methods
    var getProficiencyAriaLabel = (0, react_1.useCallback)(function (key, percentage) {
        return t("stackedBarAriaLabel.".concat(key), {
            percentage: percentage,
        });
    }, [t]);
    var parseStackedBarData = (0, react_1.useCallback)(function (data) {
        if (data) {
            var barData = data.map(function (item) { return ({
                percentage: item.percentage,
                color: (0, api_1.findPerformanceBandColor)(themeContext, (0, api_1.getCurriculumPrefixFromCurriculum)(curriculum), themeBands[item.band.code]),
                labelColor: bandLabelColor[item.band.code],
                ariaLabel: getProficiencyAriaLabel(themeBands[item.band.code], (0, api_1.formatPercentage)(item.percentage)),
            }); });
            setStackedBarData(barData);
        }
    }, [themeContext, bandLabelColor, curriculum, getProficiencyAriaLabel]);
    var loadData = (0, react_1.useCallback)(function () {
        return analyticsService
            .getOverallStandardPerformanceBandDistribution(classPerformance, bands)
            .then(function (bandsDistribution) {
            parseStackedBarData(bandsDistribution);
        })
            .catch(function () {
            toast({
                alertVariant: 'error',
                content: {
                    title: t('errorMessages.oopsErr'),
                    message: t('errorMessages.standardsMastery'),
                },
            });
        })
            .finally(function () {
            setInitialized(true);
        });
    }, 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [analyticsService, parseStackedBarData, bands, classPerformance]);
    (0, react_1.useEffect)(function () {
        if (classPerformance) {
            loadData();
        }
        else {
            setInitialized(false);
        }
    }, [classPerformance, loadData]);
    var masteryDetailByClassTitle = (0, jsx_runtime_1.jsx)("h2", { className: "h4", children: t('masteryDetailByClass.title') });
    return initialized ? ((0, jsx_runtime_1.jsx)(DpMasteryDetailByClass_styled_1.StyledMasteryDetailByClass, { "data-testid": "mastery-by-class", children: (0, jsx_runtime_1.jsxs)(DpSectionCard_1.DpSectionCard, { title: masteryDetailByClassTitle, children: [(0, jsx_runtime_1.jsx)("div", { className: "stacked-bar", children: (0, jsx_runtime_1.jsx)(DpStackedBar_1.DpStackedBar, { data: stackedBarData, variant: api_1.StackedBarVariant.OuterLabel }) }), (0, jsx_runtime_1.jsxs)("div", { className: "legend-container", children: [(0, jsx_runtime_1.jsx)(DpProficientBandLegend_1.default, { color: legendColors['not-proficient'], labelKey: themeBands['not-proficient'], ariaLabel: getProficiencyAriaLabel(themeBands['not-proficient'], (0, api_1.formatPercentage)((_c = stackedBarData[0]) === null || _c === void 0 ? void 0 : _c.percentage)), percentage: (0, api_1.formatPercentage)((_d = stackedBarData[0]) === null || _d === void 0 ? void 0 : _d.percentage) }), (0, jsx_runtime_1.jsx)(DpProficientBandLegend_1.default, { color: legendColors['partially-proficient'], labelKey: themeBands['partially-proficient'], ariaLabel: getProficiencyAriaLabel(themeBands['partially-proficient'], (0, api_1.formatPercentage)((_e = stackedBarData[1]) === null || _e === void 0 ? void 0 : _e.percentage)), percentage: (0, api_1.formatPercentage)((_f = stackedBarData[1]) === null || _f === void 0 ? void 0 : _f.percentage) }), (0, jsx_runtime_1.jsx)(DpProficientBandLegend_1.default, { color: legendColors.proficient, labelKey: themeBands.proficient, ariaLabel: getProficiencyAriaLabel(themeBands.proficient, (0, api_1.formatPercentage)((_g = stackedBarData[2]) === null || _g === void 0 ? void 0 : _g.percentage)), percentage: (0, api_1.formatPercentage)((_h = stackedBarData[2]) === null || _h === void 0 ? void 0 : _h.percentage) }), (0, jsx_runtime_1.jsx)(DpProficientBandLegend_1.default, { color: legendColors['highly-proficient'], labelKey: themeBands['highly-proficient'], ariaLabel: getProficiencyAriaLabel(themeBands['highly-proficient'], (0, api_1.formatPercentage)((_j = stackedBarData[3]) === null || _j === void 0 ? void 0 : _j.percentage)), percentage: (0, api_1.formatPercentage)((_k = stackedBarData[3]) === null || _k === void 0 ? void 0 : _k.percentage) })] })] }) })) : null;
};
exports.DpMasteryDetailByClass = DpMasteryDetailByClass;
exports.default = exports.DpMasteryDetailByClass;
